import store from '../store';
import axios from 'axios';
import _ from 'lodash';

export default {
    name: 'aggrega8Api',
    url: function () {
        if (window.location.href.startsWith("http://localhost")) return "http://localhost:8081/farmlogix"
        if (window.location.href.startsWith("http://togo-uat.local.aggrega8.com")) return "http://localhost:9001"
        if (window.location.href.startsWith("https://togo-uat.aggrega8.com")) return "https://farmlogix-to-go-uat.aggrega8.com"
        if (window.location.href.startsWith("https://togo.aggrega8.com")) return "https://farmlogix-to-go.aggrega8.com"
    },
    genHeader(config) {
        let key = store.getters.apiKey
        if (!key)
            return _.assign({}, config);
        return _.assign({headers: {'authorization': "Bearer " + key}}, config);
    },
    get(path, config) {
        return axios.get(this.url() + "/api" + path, this.genHeader(config));
    },
    post(path, data, config) {
        return axios.post(this.url() + "/api" + path, data, this.genHeader(config));
    },
    put(path, data) {
        return axios.put(this.url() + "/api" + path, data, this.genHeader());
    },
    delete(path) {
        return axios.delete(this.url() + "/api" + path, this.genHeader());
    },
    async getUserDetails() {
        await axios.get(this.url() + "/api/consumer/details", this.genHeader()).then(
        response => {
            store.dispatch("setUserDetails", response.data)
            store.dispatch("setCartSize", response.data.cartSize)
            if (!store.getters.loggedIn) store.dispatch("setLoggedIn",true)
        },
        error => {
            console.error("Error", error)
            store.dispatch("logout");
        }
        )
    }
};
